import { render } from "./block-checkbox.vue?vue&type=template&id=3993be46"
import script from "./block-checkbox.vue?vue&type=script&lang=ts"
export * from "./block-checkbox.vue?vue&type=script&lang=ts"
script.render = render

export default script